// @flow
import { assertNever } from "common/flow"
import type { Activity, Location, ProductGroup } from "data/app/types"

/** Returns a nicely formatted activity from its name */
export function formatActivity(a: ?Activity): string {
  if (!a) {
    return "Gear"
  }

  switch (a.name) {
    case "sups":
      return "SUP"
    case "surfs":
      return "Surf"
    case "skis":
      return "Ski"
    case "snowboards":
      return "Snowboard"
    case "splitboards":
      return "Splitboard"
    case "mountain_bikes":
      return "Mountain Bike"
    case "road_bikes":
      return "Road Bike"
    default:
      return assertNever(a.name)
  }
}

/**
 * Formats the heading of the product group filter for desktop
 */
export const formatProductGroupFilter = (title: string) => (v: ProductGroup[]) => {
  if (!v || v.length === 0) return title
  if (v.length === 1) return v[0].name
  return `${title} • ${v.length}`
}

export const formatLocation = (geo: Location[]): mixed =>
  geo.length > 1 ? "Nearby" : geo.map(geo => geo.name)



// WEBPACK FOOTER //
// ./src/data/app/formatters.js